var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2370 4305 c-254 -48 -450 -153 -621 -332 -156 -163 -252 -353 -294 -578 -23 -122 -16 -357 13 -467 63 -232 187 -433 357 -578 43 -36 82 -69 89 -73 8 -6 7 -10 -4 -14 -35 -14 -160 -83 -226 -125 -411 -264 -695 -747 -721 -1225 l-6 -113 165 0 165 0 6 103 c7 123 42 264 96 391 159 373 470 638 869 743 132 34 371 43 512 19 491 -86 879 -434 1016 -911 23 -78 44 -205 44 -262 0 -87 -9 -83 173 -83 l160 0 -6 113 c-17 334 -154 667 -386 934 -128 147 -289 274 -473 373 l-97 51 74 60 c172 136 313 358 377 591 20 73 23 106 23 273 0 176 -2 197 -28 290 -31 113 -95 253 -158 347 -127 188 -347 355 -569 431 -158 54 -394 72 -550 42z m360 -330 c276 -63 501 -266 584 -527 141 -443 -109 -900 -559 -1019 -111 -29 -279 -29 -389 0 -357 95 -596 400 -596 764 0 130 22 232 74 342 103 218 316 391 541 438 92 20 263 21 345 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.deaa1d01ebda3f20a6db1882dbde04b4.svg";
export { ForwardRef as ReactComponent };